import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AdminLanguageService } from '../services/admin-language-service/admin-language.service';

@Component({
    selector: 'app-wrong-login-data',
    templateUrl: './wrong-login-data.component.html',
    styleUrls: ['./wrong-login-data.component.scss'],
    standalone: false
})
export class WrongLoginDataComponent implements OnInit {
  labels;
  labelsSub: Subscription;
  constructor(public dialogRef: MatDialogRef<WrongLoginDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data,public adminLanguageService: AdminLanguageService) { }

  ngOnInit(): void {
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
        })
  }

  onNoClick(){
    this.dialogRef.close()
  }

}
